import { Component, OnInit } from "@angular/core";
import { globalApplicationVariables } from "./global-application-variables";
//import * as Raven from 'raven-js';
import * as Sentry from "@sentry/browser";

@Component({
  
  selector: 'app',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],

})
export class AppComponent implements OnInit {
  constructor(
    
  ) {
    //TODO: Should be removed
    if (window[globalApplicationVariables.globalAppConfig] && window[globalApplicationVariables.globalAppConfig].sentryKey)
      Sentry.init({dsn: window[globalApplicationVariables.globalAppConfig].sentryKey});
  }
  public status: { isopen: boolean } = { isopen: false };
  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }
  ngOnInit() {
    this.InitializePendoConfiguration();
  }

  private InitializePendoConfiguration(): void {
    const globalConfig = window[globalApplicationVariables.globalAppConfig];
    if (globalConfig.pendoFSEnabled.toString() == "true" && globalConfig.pendoApiKey.trim() !== "") {
      (function (apiKey) {
        (function (p, e, n, d) {
          var v, w, x, y, z;
          var o = p[d] = p[d] || {};
          o._q = [];
          v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
          for (w = 0, x = v.length; w < x; ++w)(function (m) {
            o[m] = o[m] || function () {
              o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
            };
          })(v[w]);
          y = e.createElement(n);
          y.async = !0;
          y.src = `https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`;
          z = e.getElementsByTagName(n)[0];
          z.parentNode.insertBefore(y, z);
        })(window, document, 'script', 'pendo');
      })(globalConfig.pendoApiKey);
    }
  }
}
